import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import { IConfigurationFormatted } from '../../../../types/project';
import * as styles from './Configuration.css';
import { CollapsedText } from '../../../CollapsedText';

type IConfigurationProps = IConfigurationFormatted;

export const Configuration: React.FC<IConfigurationProps> = ({ name, description, price }) => {
  return (
    <div className={styles['container']}>
      {(name || price) && (
        <div className={styles['header']}>
          <UIHeading2>{name}</UIHeading2>
          <UIHeading2 textAlign="right">{price}</UIHeading2>
        </div>
      )}
      {description && <CollapsedText html={description} lineHeight={24} lineCount={3} />}
    </div>
  );
};
